import { Separator, Skeleton } from "@/components/ui";

export const ProfileSkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors px-3 py-2"
      data-testid="profile-skeleton"
    >
      <div className="flex flex-col gap-2">
        <Skeleton className="h-10 w-full" />
      </div>
      <Separator />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-10 w-full" />
      </div>
      <Separator />
      <div className="flex flex-row gap-2">
        <Skeleton className="h-10 w-1/2" />
        <Skeleton className="h-10 w-1/2" />
      </div>
      <Separator />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-10 w-full" />
      </div>
    </div>
  );
};
